/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import React from "react";

import { usePlayerTranslation } from "../../../../../../shared/context/PlayerTranslationContext";
import {
  DropdownHeader,
  DropdownMenuItem,
  DropdownMenuSection,
  DropdownScrollableArea,
} from "../../../../Base";

import { useQualitySettings } from "./useQualitySettings";

export const QualitySection = () => {
  const { tracks, activeTrack, onTrackSelect } = useQualitySettings();
  const { t } = usePlayerTranslation();

  return (
    <DropdownMenuSection name="quality">
      <DropdownHeader navigateToSection="settings">
        {t("PLAYER_SETTINGS_QUALITY")}
      </DropdownHeader>
      <DropdownScrollableArea>
        {tracks.map((track) => {
          return (
            <DropdownMenuItem
              key={track.id}
              onItemSelect={() => onTrackSelect(track)}
              active={activeTrack && track.id === activeTrack.id}
              resetToDefaultSectionAfterSelect
              showActiveIcon
            >
              {track.label}
            </DropdownMenuItem>
          );
        })}
      </DropdownScrollableArea>
    </DropdownMenuSection>
  );
};
